import { useMemo } from 'react';

import { staticRoutes } from 'Deer/constants/routes';
import { useRouteToNavLevels } from 'Deer/hooks/useRouteToL3';
import { IntentFilters } from 'Deer/intent/components/Layout/IntentFilters.layout';
import { IntentBreadcrumbType } from 'Deer/intent/types/IntentCommonTypes';
import { useHistory, useLocation } from 'react-router-dom';

type PlatformIntentDropdownProps = {
  breadcrumbs: IntentBreadcrumbType;
};

export const PlatformIntentDropdown = ({ breadcrumbs }: PlatformIntentDropdownProps) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const { l1Module } = useRouteToNavLevels();

  const PLATFORM_SETTINGS_INTENT = useMemo(
    () => [
      {
        label: 'Organisational details',
        visible: () => true,
        onClick: () => {
          history.push(staticRoutes.company.settings.platform.organization);
        },
        category: 'PLATFORM',
        value: {
          company: {
            path: staticRoutes.company.settings.platform.organization,
          },
        },
      },
      {
        label: 'Function tree',
        visible: () => true,
        onClick: () => {
          history.push(staticRoutes.company.settings.platform['function-grade']);
        },
        category: 'PLATFORM',
        value: {
          company: {
            path: staticRoutes.company.settings.platform['function-grade'],
          },
        },
      },
    ],
    [history]
  );

  const selectedIntent = useMemo(
    () => PLATFORM_SETTINGS_INTENT.find((option) => pathname.includes(option.value[l1Module].path)),
    [PLATFORM_SETTINGS_INTENT, pathname, l1Module]
  );

  return (
    <IntentFilters
      intentDropdownOptions={PLATFORM_SETTINGS_INTENT}
      selectedIntent={selectedIntent?.label ?? ''}
      moduleName="settings"
      breadcrumbs={breadcrumbs}
      isCategorized={false}
      intentTitle="Platform Settings"
    />
  );
};
